module.exports = __webpack_public_path__ + "img/not-find.a5d85516.png";